module.exports = __webpack_public_path__ + "img/7818.d2ed004b.svg";